import { render, staticRenderFns } from "./ElHipotekaBusena.vue?vue&type=template&id=812d48aa&scoped=true&"
import script from "./ElHipotekaBusena.vue?vue&type=script&lang=js&"
export * from "./ElHipotekaBusena.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812d48aa",
  null
  
)

export default component.exports